export default __webpack_public_path__ + "f35b37499721b7ecd3c30626dee59239.png";